
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { EmailLog } from "@/hooks/useNotificationAnalytics";

interface EmailLogsTableProps {
  emailLogs: EmailLog[];
}

const EmailLogsTable = ({ emailLogs }: EmailLogsTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Delivery Logs</CardTitle>
        <CardDescription>Recent email notification delivery attempts</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Email</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Sent At</TableHead>
              <TableHead>Provider ID</TableHead>
              <TableHead>Retries</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {emailLogs.slice(0, 20).map((log) => (
              <TableRow key={log.id}>
                <TableCell className="font-medium">{log.email_address}</TableCell>
                <TableCell>
                  <Badge 
                    variant={
                      log.status === 'sent' ? "default" : 
                      log.status === 'failed' ? "destructive" : 
                      "secondary"
                    }
                  >
                    {log.status}
                  </Badge>
                </TableCell>
                <TableCell>
                  {log.sent_at ? new Date(log.sent_at).toLocaleString() : '-'}
                </TableCell>
                <TableCell className="font-mono text-xs">
                  {log.provider_id ? log.provider_id.substring(0, 8) + '...' : '-'}
                </TableCell>
                <TableCell>{log.retry_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default EmailLogsTable;
